export default __webpack_public_path__ + "static/media/airplane.61f623ae.svg";